module.exports = __webpack_public_path__ + "img/moishop_portfolio_5_mob_2x.47cd1685.png";